<template>
    <div>
        <ns-loader
            :fetch-timer="null"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
            ref="treeLoader"
        >
            <template slot="content">
                <el-tree
                    :data="formattedTreeData"
                    node-key="id"
                    default-expand-all
                    :expand-on-click-node="false"
                    class="tree-structure"
                >
                    <template slot-scope="{ node, data }">
                        <component 
                            :ref="`${data.props.uid}-component`"
                            :is="data.component" 
                            :componentData="data.props"
                            :class="selectedItem === data.props.uid?'is-selected':''" 
                            @refreshTree="reloadData"
                            @enableActionButtons="enableActionButtons"
                            @click.native="setSelectedItem(data.props.uid)"
                        />
                    </template>
                </el-tree>
            </template>
        </ns-loader>
    </div>
</template>

<script>
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2';
import ZoneCard from '@/components/page/Synoptic/Areas/ZoneCard.vue';
import WorkshopCard from '@/components/page/Synoptic/Areas/WorkshopCard.vue';
import MachineCard from '@/components/page/Synoptic/Equipments/MachineCard.vue';
import MotorCard from '@/components/page/Synoptic/Equipments/MotorCard.vue';
import { mapGetters } from 'vuex';
    export default {
        name: 'TreeStructure',
        components: {
            NsLoader,
            ZoneCard,
            WorkshopCard
        },
        data() {
            return {
                areas: [],
                equipments: [],
            };
        },
        computed: {
            ...mapGetters(['currentSite', 'selectedItem']),
            toLoad() {
                return [
                    {
                        name: 'areas',
                        model: 'area',
                        filters: {
                            parent_site_uid: this.currentSite.uid,
                            archived: false,
                            ordering: 'creation_date'
                        },
                    },
                    {
                        name: 'equipments',
                        model: 'equipment',
                        filters: {
                            archived: false,
                            parent_site_uid: this.currentSite.uid,
                            ordering: 'creation_date'
                        },
                    },
                    {
                        name: 'equipmentSets',
                        model: 'equipment',
                        sets: true,
                        filters: {
                            archived: false,
                            parent_site_uid: this.currentSite.uid,
                            ordering: 'creation_date'
                        },
                    },
                    {
                        name: 'areaSets',
                        model: 'area',
                        sets: true,
                        filters: {
                            parent_site_uid: this.currentSite.uid,
                            archived: false,
                            ordering: 'creation_date'
                        },
                    },
                    {
                        name: 'currentSimulation',
                        model: 'simulations',
                        filters: {
                            related_site_uid: this.currentSite.uid,
                            is_latest: true,
                            archived: false,
                            status: 'COMPLETED',
                        },
                    }
                ]
            },
            zones(){
                return this.areas.filter(area => area.parent_area_uid !== null);
            },
            workshops(){
                return this.areas.filter(area => area.parent_area_uid === null);
            },
            formattedTreeData(){
                let data = [];
                if(this.workshops.length > 0){
                    this.workshops.map(workshop => {
                        data.push({
                            id: workshop.uid,
                            label: workshop.name,
                            props: {...workshop, entity: 'workshop' },
                            component: WorkshopCard,
                            children: [
                                 ...this.equipments.filter(equipment => equipment.parent_area_uid === workshop.uid).map(equipment => {
                                    return {
                                        id: equipment.uid,
                                        label: equipment.name,
                                        props: {...equipment, entity: 'equipment', isWorkshopChild: true },
                                        component: equipment.equipment_type === 'motor' ? MotorCard : MachineCard
                                    }
                                }),
                                ...this.zones.map(zone => {
                                    if(zone.parent_area_uid === workshop.uid) {
                                        return {
                                            id: zone.uid,
                                            label: zone.name,
                                            props: {...zone, entity: 'zone' },
                                            component: ZoneCard,
                                            children: this.equipments.filter(equipment => equipment.parent_area_uid === zone.uid).map(equipment => {
                                                return {
                                                    id: equipment.uid,
                                                    label: equipment.name,
                                                    props: {...equipment, entity: 'equipment' },
                                                    component: equipment.equipment_type === 'motor' ? MotorCard : MachineCard
                                                }
                                            })
                                        }
                                    } else {
                                        return null;
                                    }
                                }).filter(zone => zone !== null)
                            ]
                        });
                    });
                }
                return data;
            }
        },
        mounted() {
            this.$store.commit('UNSET_CURRENT_AREA');
            this.$store.commit('UNSET_CURRENT_EQUIPMENT');
        },
        methods: {
            reloadData(){
                this.$refs.treeLoader.triggerRefresh();
                if(this.$store.getters.currentSimulation){
                    this.areas.forEach(area => {
                        if(this.$refs && this.$refs[`${area.uid}-component`]){    
                            this.$refs[`${area.uid}-component`].refreshConsumptionPercent();
                        }
                    });
                    this.equipments.forEach(equipment => {
                        if(this.$refs && this.$refs[`${equipment.uid}-component`]){
                            this.$refs[`${equipment.uid}-component`].refreshConsumptionPercent();
                        }
                    });
                }
            },
            onDataFetched(res) {
                if(res.currentSimulation){
                    this.$store.commit('SET_CURRENT_SIMULATION', res.currentSimulation[0] ? res.currentSimulation[0] : null);
                } else {
                    this.$store.commit('SET_CURRENT_SIMULATION', null);
                }
                if(res.areas){
                    this.$set(this, 'areas', res.areas);
                }
                if(res.equipments){
                    this.$set(this, 'equipments', res.equipments);
                }
                // Save existing energy meter names for future validation
                let energyMeterNames = [this.currentSite.energy_meter_name]
                if(res.areaSets){
                    energyMeterNames = [...energyMeterNames, ...res.areaSets.energy_meter_name]
                }
                if(res.equipmentSets){
                    energyMeterNames = [...energyMeterNames, ...res.equipmentSets.energy_meter_name]
                }
                this.setAllMeasureFilesRelatedData()
                this.$store.commit('SET_CURRENT_ENERGY_METER_NAMES', energyMeterNames.filter(name => name !== ''));
            },
            enableActionButtons(props){
                this.$emit('enableActionButtons', props);
            },
            setAllMeasureFilesRelatedData(){
                const activeAreaUids = this.areas.map(a => a.uid)
                const validEquipments = this.equipments.filter(
                    e => (!e.parent_area_uid || activeAreaUids.includes(e.parent_area_uid)) && e.energy_meter !== 'virtual_meter'
                )
                const totalItemCount = this.areas.filter(area => area.energy_meter !== 'virtual_meter').length + validEquipments.length + 1 // +1 pour le site

                const totalAreaMeasureFiles = this.areas.filter(
                    area => area.simulation_measure_uid !== null && area.energy_meter !== 'virtual_meter'
                ).length

                const totalEquipmentMeasureFiles = validEquipments.filter(
                    e => e.simulation_measure_uid !== null && e.energy_meter !== 'virtual_meter'
                ).length

                const siteHasMeasureFile = this.currentSite.simulation_measure_uid !== null
                const totalMeasureFiles =
                    totalAreaMeasureFiles +
                    totalEquipmentMeasureFiles +
                    (siteHasMeasureFile ? 1 : 0)

                console.log ('totalMeasureFiles', totalMeasureFiles, 'totalItemCount', totalItemCount)
                this.$store.commit(
                    'SET_ALL_MEASURE_FILES_LOADED',
                    totalItemCount === totalMeasureFiles
                )

                if(totalItemCount === totalMeasureFiles){
                    let allMeasureFilesUids = [
                        ...this.areas.filter(area => area.simulation_measure_uid && area.energy_meter !== 'virtual_meter').map(area => area.simulation_measure_uid),
                        ...validEquipments.filter(e => e.simulation_measure_uid && e.energy_meter !== 'virtual_meter').map(e => e.simulation_measure_uid),
                        this.currentSite.simulation_measure_uid
                    ]
                    console.log('allMeasureFilesUids', allMeasureFilesUids)
                    this.$store.commit('SET_ALL_MEASURE_FILES_UIDS', allMeasureFilesUids);
                }

            },
            setSelectedItem(uid){
                this.$store.commit('SET_SELECTED_ITEM', uid)
            }
        }
    }
</script>

<style lang="scss">
.tree-structure {
    background: none;
    .el-tree-node__content{
        height: 100%;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/page/Synoptic/TreeStructure.vue